import { useQueryClient, useMutation } from '@tanstack/react-query';
import { Api } from 'hooks';
import useModal from 'ui/partials/Modal/useModal';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';
import { withAcl } from 'hooks/Api';

import c from '../../utils/constants';

const useOutlookBulkMarkThreadAsRead = () => {
  const queryClient = useQueryClient();
  const { accountId, accountUserId } = useAdminParams();
  const { hideModal } = useModal();

  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async ({
      messageIds = [],
      from,
    }: {
      messageIds: string[];
      from: string;
    }) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: `api/v1/channels/azure/mail/mark-as-read/`,
            params: { from },
            payload: {
              messageIds,
            },
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/azure/mail/mark-as-read/`,
            params: { from },
            payload: {
              messageIds,
            },
          },
        }),
      );

      return data?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [c.OUTLOOK_MESSAGES],
      });
      hideModal();
    },
  });
};

export default useOutlookBulkMarkThreadAsRead;
